export default __webpack_public_path__ + "static/media/erica_1.3580032b.png";